import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button
} from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const StorageBrowserReplaceDialog = ({
  open,
  onClose,
  onConfirm,
  duplicateNames = [],
  primaryColor = '#5757b0',
  t = (key, fallback) => fallback
}) => {
  const duplicates = Array.isArray(duplicateNames) ? duplicateNames : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pb: 1.5,
          background: `linear-gradient(135deg, ${primaryColor}22, ${primaryColor}10)`,
        }}
      >
        <ReportProblemIcon sx={{ color: primaryColor }} />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {t('sidebar.storage_replace_title', 'Replace existing files?')}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t('sidebar.storage_replace_subtitle', 'Duplicates were found in this folder.')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 2.5 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1, mb: 2 }}>
          {t('sidebar.storage_replace_message', 'These files already exist in this folder. Do you want to replace them?')}
        </Typography>
        {duplicates.length > 0 && (
          <Box sx={{
            maxHeight: 200,
            overflow: 'auto',
            borderRadius: 2,
            border: `1px solid ${primaryColor}33`,
            backgroundColor: `${primaryColor}0f`,
            p: 1.5
          }}>
            {duplicates.map((name) => (
              <Typography key={name} variant="caption" sx={{ display: 'block', wordBreak: 'break-all', fontFamily: 'monospace' }}>
                {name}
              </Typography>
            ))}
          </Box>
        )}
        <Typography variant="caption" sx={{ display: 'block', mt: 1.5, color: 'text.secondary' }}>
          {t('sidebar.storage_replace_hint', 'Replaced files cannot be recovered.')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button variant="contained" color="warning" onClick={onConfirm}>
          {t('sidebar.storage_replace_confirm', 'Replace')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StorageBrowserReplaceDialog;
